import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';

import { IconChevronDown, IconChevronUp, Pressable, Text, tokens } from '@fhs/ui';

export interface ServiceModeAccordionProps {
  selectedServiceModeLabel: string;
  selectedServiceModeDescription?: string;
  children: React.ReactNode;
}

export function ServiceModeAccordion({
  selectedServiceModeLabel,
  selectedServiceModeDescription,
  children,
}: ServiceModeAccordionProps) {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleToggle = () => {
    const newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);
  };

  return (
    <View style={styles.container}>
      <Pressable
        onPress={handleToggle}
        style={[styles.trigger, isExpanded && { borderBottomWidth: 0 }]}
        accessibilityRole="button"
        accessibilityState={{ expanded: isExpanded }}
        accessibilityLabel={`Pickup mode: ${selectedServiceModeLabel}. Tap to ${
          isExpanded ? 'collapse' : 'expand'
        } options`}
      >
        <View style={styles.triggerContent}>
          <View style={styles.triggerTextContainer}>
            <Text.Ui size="sm">Pickup Mode</Text.Ui>
            <Text.Ui size="md" weight="bold">
              {selectedServiceModeLabel}
            </Text.Ui>
            <Text.Ui size="sm">{selectedServiceModeDescription}</Text.Ui>
          </View>
          <View style={styles.chevronContainer}>
            {isExpanded ? (
              <IconChevronUp size={20} color={tokens.colors.$black} />
            ) : (
              <IconChevronDown size={20} color={tokens.colors.$black} />
            )}
          </View>
        </View>
      </Pressable>

      <View style={[styles.content, !isExpanded && styles.contentCollapsed]}>
        {isExpanded && children}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  trigger: {
    paddingVertical: 16,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderRadius: 8,
  },
  triggerContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  triggerTextContainer: {
    flex: 1,
    gap: 2,
  },
  chevronContainer: {
    marginLeft: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    marginTop: 5,
  },
  contentCollapsed: {
    height: 0,
    overflow: 'hidden',
    marginTop: 0,
    borderWidth: 0,
  },
});
